import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const adminContract = c.router({
  resetFileHashes: {
    method: "POST",
    path: "/admin/reset-file-hashes",
    responses: {
      200: z.object({
        updatedCount: z.number(),
        message: z.string(),
      }),
    },
    body: z.object({}),
    summary: "Reset all file hashes in the database",
  },
});
